module.exports = __webpack_public_path__ + "img/about1.4bfc1573.png";